
import { useTranslation } from 'react-i18next';

export default function ValuesSection() {
  const { t } = useTranslation();
  
  const values = [
    {
      title: t('values.innovation.title'),
      description: t('values.innovation.description'),
      icon: "ri-lightbulb-line"
    },
    {
      title: t('values.integrity.title'), 
      description: t('values.integrity.description'),
      icon: "ri-shield-star-line"
    },
    {
      title: t('values.collaboration.title'),
      description: t('values.collaboration.description'),
      icon: "ri-team-line"
    },
    {
      title: t('values.excellence.title'),
      description: t('values.excellence.description'),
      icon: "ri-award-line"
    },
    {
      title: t('values.sustainability.title'),
      description: t('values.sustainability.description'),
      icon: "ri-leaf-line"
    }
  ];

  return (
    <section className="py-20 bg-gray-50">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-emerald-600 font-semibold text-sm uppercase tracking-wide mb-4">
            {t('values.badge')}
          </p>
          <h2 className="text-4xl font-bold text-gray-800 mb-6">
            {t('values.title')}
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            {t('values.subtitle')}
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {values.map((value, index) => (
            <div 
              key={index}
              className="group bg-white rounded-lg p-8 shadow-lg hover:shadow-xl transition-all duration-300 hover:-translate-y-2"
            >
              <div className="w-16 h-16 flex items-center justify-center bg-emerald-100 rounded-lg mb-6 group-hover:bg-emerald-600 group-hover:text-white transition-colors duration-300">
                <i className={`${value.icon} text-3xl text-emerald-600 group-hover:text-white`}></i>
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">{value.title}</h3>
              <p className="text-gray-600 leading-relaxed">{value.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
